export const MatchOptionColorGroup = {
  // looking up options.sidingColor vs option color groups.
  SidingColor: 'siding-color',
  TrimColor: 'trim-color',
};
